(function () {
  'use strict';

  /* ── Sticky offset ──────────────────────────────────────────
     Measures the rendered .header-wrapper height and writes it
     to --wand-sticky-offset so the sticky panel never overlaps
     the header regardless of announcement-bar / sticky state.  */
  function setWandStickyOffset() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    if (h > 0) {
      /* Add 8px breathing room above the panel */
      document.documentElement.style.setProperty('--wand-sticky-offset', (h + 8) + 'px');
    }
  }

  /* ── Smooth accordion animation ─────────────────────────────
     JS measures exact scrollHeight so the CSS transition runs
     at the correct speed regardless of content length.
     CSS provides a max-height:2400px fallback for the initial
     is-open item so content is visible before JS executes.    */

  function openItem(item, btn, body) {
    /* Measure before adding is-open (body is still at max-height:0) */
    var targetH = body.scrollHeight;
    item.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    /* Inline override triggers transition from 0 → exact height */
    body.style.maxHeight = targetH + 'px';
    body.addEventListener('transitionend', function onEnd() {
      /* Remove constraint so content can grow (e.g. review app injects) */
      if (item.classList.contains('is-open')) body.style.maxHeight = 'none';
      body.removeEventListener('transitionend', onEnd);
    });
  }

  function closeItem(item, btn, body) {
    /* Lock at current rendered height so the downward transition fires */
    body.style.maxHeight = body.scrollHeight + 'px';
    body.offsetHeight; /* flush layout */
    body.style.maxHeight = '0';
    btn.setAttribute('aria-expanded', 'false');
    body.addEventListener('transitionend', function onEnd() {
      item.classList.remove('is-open');
      body.style.maxHeight = '';   /* hand control back to CSS */
      body.removeEventListener('transitionend', onEnd);
    });
  }

  /* ── Accordion init ──────────────────────────────────────── */
  function initWandAccordion(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wand-accordion-item]').forEach(function (item) {
      var btn  = item.querySelector('.wand-product-accordion-item__header');
      var body = item.querySelector('.wand-product-accordion-item__body');
      if (!btn || !body || btn.dataset.wandAccordionBound) return;
      btn.dataset.wandAccordionBound = '1';

      /* Sync initial aria-expanded with DOM state */
      btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');

      btn.addEventListener('click', function () {
        if (item.classList.contains('is-open')) {
          closeItem(item, btn, body);
        } else {
          openItem(item, btn, body);
        }
      });

      /* Arrow keys move focus between accordion headers */
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var all = Array.from(
          scope.querySelectorAll('.wand-product-accordion-item__header')
        );
        var idx  = all.indexOf(btn);
        var next = all[idx + (e.key === 'ArrowDown' ? 1 : -1)];
        if (next) next.focus();
      });
    });

    /* Fix the initially-open Description item:
       after JS runs the CSS fallback (max-height:2400px) is replaced
       with the exact measured height so close animation is smooth. */
    scope.querySelectorAll(
      '.wand-product-accordion-item.is-open .wand-product-accordion-item__body'
    ).forEach(function (body) {
      if (body.style.maxHeight === 'none') return; /* already measured */
      var h = body.scrollHeight;
      if (h > 0) {
        body.style.maxHeight = h + 'px';
        /* After a tick, release constraint so content can grow freely */
        setTimeout(function () { body.style.maxHeight = 'none'; }, 50);
      }
    });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  function init() {
    setWandStickyOffset();
    initWandAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-measure on resize (announcement bar may collapse/expand).
     Coalesce bursts of resize events (mobile URL-bar show/hide, orientation
     change) into one getBoundingClientRect read per frame to avoid layout
     thrash — behaviour is identical, just batched. */
  var stickyRafPending = false;
  window.addEventListener('resize', function () {
    if (stickyRafPending) return;
    stickyRafPending = true;
    requestAnimationFrame(function () {
      stickyRafPending = false;
      setWandStickyOffset();
    });
  }, { passive: true });

  /* Re-init when Shopify theme editor reloads a section */
  document.addEventListener('shopify:section:load', function (e) {
    setWandStickyOffset();
    initWandAccordion(e.target);
  });
})();
